<template>
  <div class="apply-cash wrap-content">
    <Card dis-hover>
      <div>
        <Steps :current="current">
          <Step title="填写提现金额"></Step>
          <Step title="确认提现信息"></Step>
          <Step title="提现申请成功，请耐心等候到账"></Step>
        </Steps>
        <div class="g-jc-ai">
          <Form :label-width="120" v-if="current === 0">
            <FormItem label="开户银行：">
              <span>{{userInfo.bankName}}</span>
            </FormItem>
            <FormItem label="银行卡号：">
              <span>{{userInfo.bankCard}}</span>
            </FormItem>
            <FormItem label="本月已提金额：">
              <span>{{userInfo.moneyMention}}</span>
            </FormItem>
            <FormItem label="转账金额：">
              <InputNumber placeholder="请输入转账金额" style="width:160px" v-model="money" @on-blur="handleTaxes"></InputNumber>
              <span style="margin-left:10px">可提现余额：</span>
              <span class="sum">{{userInfo.canWithdrawal}}</span>
              <span>元</span>
            </FormItem>
            <Alert show-icon>根据国家税法，劳动报酬个人所得税每月超过800元，需缴纳个人所得税。<br>
            建议：每月提现不超过800元，超过金额，按照20%收取税费。</Alert>
            <FormItem label="应缴税费：">
              <span>{{expenses}}</span>
            </FormItem>
            <FormItem label="手机号：">
              <span>{{userInfo.mobile}}</span>
              <InputNumber placeholder="请输入验证码" style="width:160px;margin-left:10px" v-model="numberCode"></InputNumber>
              <Button @click="handleAuthCode" v-if="totalCount <= 0">获取验证码</Button>
              <Button v-else>{{totalCount}}s</Button>
            </FormItem>
            <div class="g-jc-ai g-mt-20">
              <Button type="primary" @click="handleNext" v-if="this.numberCode && this.money">下一步</Button>
              <Button type="primary" disabled v-else>下一步</Button>
            </div>
          </Form>
          <Form :label-width="120" v-if="current === 1">
            <Alert show-icon class="g-mt-20">请仔细核对您的账户信息，如信息有误，将导致提现失败，资金将退回您的账户。</Alert>
            <FormItem label="提现账户：">
              <span>{{userInfo.bankCard}}</span>
            </FormItem>
            <FormItem label="提现金额：">
              <span class="sum">{{money}}</span>
              <span>元</span>
            </FormItem>
            <FormItem label="提现税费：">
              <span class="sum">{{expenses}}</span>
              <span>元</span>
            </FormItem>
            <FormItem label="实际到账：">
              <span class="sum">{{money - expenses}}</span>
              <span>元</span>
            </FormItem>
            <div class="g-jc-ai g-mt-20">
              <Button type="primary" @click="handleSubmit">提交</Button>
              <Button class="g-ml" @click="handleLastStep">上一步</Button>
            </div>
          </Form>
          <div class="g-ta-c" v-if="current === 2">
            <Icon type="ios-checkmark-circle" class="btn-success"/>
            <p class="text-success">操作成功</p>
            <p style="color: rgba(0, 0, 0, 0.43);">您的提现申请已成功提交，请耐心等待到帐！</p>
          </div>
        </div>
      </div>
      <Card class="g-mt-20" dis-hover>
        <p slot="title">账单明细</p>
        <regular-page
          ref="configTable"
          config-path="/enrolment/regular/fundsManage/applyCash"
        ></regular-page>
      </Card>
    </Card>
    </div>
</template>
<script>
import regularPage from '@/layout/regularPage';
export default {
  name: 'applyCash',
  components: { regularPage },
  data () {
    return {
      current: 0,
      userInfo: {},
      money: '',
      expenses: '',
      numberCode: '',
      validationsmsCode: '',
      totalCount: 0,
      interval: null
    };
  },
  created () {
    this.fetchUserInfo()
    if (this.current === 1) {
      this.fetchBankInfo()
    }
  },
  methods: {
    // 获取用户信息
    fetchUserInfo () {
      this.post('/finance/payBillDetail/selectBillInfo').then(res => {
        this.userInfo = res.data
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
        this.$router.push('/shell/custom/userInfoManage/userInfo')
      });
    },
    // 下一步
    handleNext () {
      this.fetch('/finance/payBillDetail/validationsmsCode', {number: this.numberCode}).then(res => {
        if (Number(this.numberCode) === Number(this.validationsmsCode)) {
          if (this.current === 2) {
            this.current = 0;
          } else {
            this.current += 1;
          }
        } else {
          this.$Message.warning('请输入正确的验证码')
        }
      })
    },
    // 上一步
    handleLastStep () {
      this.current -= 1;
    },
    // 提交
    handleSubmit () {
      this.fetchBankInfo()
    },
    // 获取验证码
    handleAuthCode () {
      this.fetch('/finance/payBillDetail/BillSMSCode', {mobile: this.userInfo.mobile}).then(res => {
        this.$Message.success(res.msg)
        const _self = this
        _self.totalCount = 60
        _self.interval = setInterval(function () {
          _self.totalCount--;
          if (_self.totalCount === 0) {
            clearInterval(_self.interval);
          }
        }, 1000)
        this.validationsmsCode = res.data
      })
    },
    // 计算应缴税费
    handleTaxes () {
      if (Number(this.money) > Number(this.userInfo.canWithdrawal)) {
        this.$Message.warning(`转账金额最大为${this.userInfo.canWithdrawal}`)
      } else {
        this.fetch('/finance/payBillDetail/calculateMoney', {money: this.money}).then(res => {
          this.expenses = res.data
        })
      }
    },
    fetchBankInfo () {
      this.fetch('/finance/payBillDetail/applyGetBill', {money: this.money}).then(res => {
        this.current = 2;
        this.$refs['configTable'].reload();
      })
    }
  }
};
</script>
<style lang='less' scoped>
.apply-cash {
  .sum {
    font-size: 20px;
  }
  .btn-success {
    font-size: 80px;
    color: #52C41A;
  }
  .text-success {
    font-size: 24px;
    margin: 24px 0 8px;
  }
}
</style>
<style lang='less'>
.apply-cash {
  .kh-steps {
    text-align: center;
    padding-top: 20px;
  }
  .kh-steps-item {
    width: 20% !important;
  }
  .kh-steps .kh-steps-tail {
    left: 50%;
  }
  .kh-card-bordered {
    border: 0;
  }
  .kh-steps .kh-steps-title {
    display: block;
    padding-right: 0;
    padding-bottom: 20px;
  }
  .kh-form .kh-form-item-label {
    padding: 10px 0 10px 0;
  }
  .kh-card-head {
    border-bottom: 0px solid #e8eaec;
    border-top: 1px solid #e8eaec;
  }
  .kh-card-body {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/customPage/fundsManage/applyCash.vue